import type { TCity, TConfig, TContentSection, TTag, TTeam, TUser, TUserDetails, TUserTag } from "@/types"
import { api } from "./api"
import { generateAPIResource, generateSetupActivity } from "./utils"

// Common APIs
export const userAPI = {
  ...generateAPIResource<TUser>("/people/user"),
  details: (id: string) => api.get<TUserDetails>(`/people/user/${id}/details`).then((res) => res.data),
}
export const peopleSetupAPI = generateSetupActivity("/people")
export const teamAPI = generateAPIResource<TTeam>("/people/teams")
export const cityAPI = generateAPIResource<TCity>("/geo/cities", {
  create: false,
  update: false,
  remove: false,
})
export const tagsAPI = generateAPIResource<TTag>("/tags", {
  create: false,
  update: false,
  remove: false,
})
export const usertagsAPI = generateAPIResource<TUserTag>("/usertags", {
  create: false,
  update: false,
  remove: false,
})

export const contentAPI = generateAPIResource<TContentSection>("/content")

export const configAPI = { fetch: () => api.get<TConfig>("/config").then((res) => res.data) }

export async function fetchAPIStats({ where, limit }: { where: unknown; limit?: number }) {
  const res = await api.get("/stats", {
    params: {
      where,
      ...(limit ? { limit } : {}),
    },
  })
  return res.data
}
